module.exports = __webpack_public_path__ + "static/fonts/fontello.a782baa8.woff";